"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorSwatch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_color_1 = require("react-color");
var color_1 = __importDefault(require("color"));
var Field_1 = require("./Field");
var hooks_1 = require("../../hooks");
var utils_1 = require("utils");
var Overlay_1 = require("../Overlay");
var clsx_1 = __importDefault(require("clsx"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var FIELD_LABEL_STYLES = "capitalize font-semibold text-base mb-1";
var CONTAINER_STYLES = "w-full";
var BUTTON_STYLES = "w-full flex focus:outline-none shadow rounded relative";
var ColorSwatch = function (_a) {
    var _b, _c;
    var id = _a.id, label = _a.label, name = _a.name, className = _a.className, errorMessage = _a.errorMessage, disabled = _a.disabled, errors = _a.errors, style = _a.style, colors = _a.colors, _d = _a.defaultValue, defaultValue = _d === void 0 ? "#ffffff" : _d, value = _a.value, onChange = _a.onChange, fieldProps = __rest(_a, ["id", "label", "name", "className", "errorMessage", "disabled", "errors", "style", "colors", "defaultValue", "value", "onChange"]);
    var determinedErrorMessage = (0, Field_1.getErrorMessage)({
        name: name,
        errorMessage: errorMessage,
        errors: errors,
    });
    var _e = (0, react_1.useState)(false), advanced = _e[0], setAdvanced = _e[1];
    var _f = (0, react_1.useState)(defaultValue), color = _f[0], setColor = _f[1];
    var _g = (0, react_1.useState)(false), show = _g[0], toggle = _g[1];
    var containerRef = (0, react_1.useRef)(null);
    var buttonRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (color !== value && value) {
            setColor(value);
        }
    }, [setColor, value, color]);
    var dismiss = function () {
        toggle(false);
    };
    (0, hooks_1.useClickAway)(containerRef, dismiss, buttonRef);
    var handleOnClick = function (e) {
        e.preventDefault();
        disabled ? toggle(false) : toggle(function (prev) { return !prev; });
    };
    var handleOnChange = function (_a) {
        var hex = _a.hex;
        setColor(hex);
        onChange === null || onChange === void 0 ? void 0 : onChange(hex);
    };
    var handleSelectColor = function (e) {
        e.preventDefault();
        onChange === null || onChange === void 0 ? void 0 : onChange(color);
        dismiss();
    };
    var handleToggleAdvanced = function (e) {
        e.preventDefault();
        setAdvanced(!advanced);
    };
    var handleUpdatedColorField = function (color) {
        setColor(color);
        onChange === null || onChange === void 0 ? void 0 : onChange(color);
        dismiss();
    };
    var _h = (_c = (_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) !== null && _c !== void 0 ? _c : {
        x: 0,
        y: 0,
        height: 0,
    }, x = _h.x, y = _h.y, height = _h.height;
    var top = y + height + 5, left = x;
    return ((0, jsx_runtime_1.jsx)(Field_1.Field, __assign({ name: name, label: label, className: (0, utils_1.concatStyles)(className, "w-full"), labelClassName: FIELD_LABEL_STYLES, style: style, errorMessage: determinedErrorMessage }, fieldProps, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: CONTAINER_STYLES }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)(BUTTON_STYLES, disabled && "opacity-50 pointer-events-none"), ref: buttonRef, style: {
                        backgroundColor: color,
                        color: (0, color_1.default)(color).isLight() ? "#000" : "#FFF",
                    } }, { children: [(0, jsx_runtime_1.jsx)(ColorInput, { color: color, onChange: handleUpdatedColorField, className: "uppercase font-bold text-left px-2 py-5 w-28 mx-auto outline-none focus:outline-none" }, void 0), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: handleOnClick, className: "absolute right-0 pl-2 inset-y-0 flex bg-black/10" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faChevronCircleDown, className: "my-auto mr-2" }, void 0) }), void 0)] }), void 0), show ? ((0, jsx_runtime_1.jsx)(Overlay_1.Overlay, { children: (0, jsx_runtime_1.jsx)(PositionAbsolute, __assign({ top: top, left: left, zIndex: 999, ref: containerRef }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col pt-1 px-2 pb-2 mt-1 bg-white rounded shadow" }, { children: [advanced ? ((0, jsx_runtime_1.jsx)(react_color_1.SketchPicker, { color: color, presetColors: colors, onChangeComplete: handleOnChange }, void 0)) : ((0, jsx_runtime_1.jsx)(react_color_1.BlockPicker, { color: color, colors: colors, onChangeComplete: handleOnChange }, void 0)), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: handleSelectColor, className: "text-white uppercase font-bold text-sm p-2 rounded mx-auto bg-sorbus-default mt-2 w-full shadow" }, { children: "Set Color" }), void 0), (0, jsx_runtime_1.jsxs)("button", __assign({ onClick: handleToggleAdvanced, className: "text-lochivar-default uppercase bg-white text-xs p-1 rounded mx-auto border border-lochivar-default mt-2 w-full shadow" }, { children: ["Use ", advanced ? "Basic" : "Advanced", " Mode"] }), void 0)] }), void 0) }), void 0) }, void 0)) : null] }), void 0) }), void 0));
};
exports.ColorSwatch = ColorSwatch;
var ColorInput = function (_a) {
    var color = _a.color, onChange = _a.onChange, className = _a.className, style = _a.style;
    var _b = (0, react_1.useState)(color), userInput = _b[0], setUserInput = _b[1];
    var _c = (0, react_1.useState)(false), editing = _c[0], setEditing = _c[1];
    var _d = (0, react_1.useState)(true), valid = _d[0], setValid = _d[1];
    (0, react_1.useEffect)(function () {
        if (color !== userInput && !editing) {
            setUserInput(color);
            setValid(true);
        }
    }, [color, userInput, setUserInput, editing]);
    var isValidColor = function (str) {
        return (str.match(/^#[a-f0-9]{6}$/i) !== null ||
            str.match(/^#[a-f0-9]{3}$/i) !== null);
    };
    var focusHandler = function () {
        setEditing(true);
    };
    var blurHandler = function () {
        setEditing(false);
        if (valid) {
            onChange(userInput);
        }
    };
    var changeHandler = function (e) {
        e.preventDefault();
        setUserInput(e.target.value);
        var nowValid = isValidColor(e.target.value);
        setValid(nowValid);
        if (nowValid) {
            onChange(e.target.value);
        }
    };
    return ((0, jsx_runtime_1.jsx)("input", { name: "color", type: "text", className: (0, clsx_1.default)("rounded bg-transparent", className), style: style, placeholder: "#ff9900", value: userInput, onChange: changeHandler, onFocus: focusHandler, onBlur: blurHandler }, void 0));
};
var PositionAbsolute = react_1.default.forwardRef(function (_a, ref) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom, zIndex = _a.zIndex, children = _a.children, className = _a.className, props = __rest(_a, ["top", "left", "right", "bottom", "zIndex", "children", "className"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: ref, className: (0, utils_1.concatStyles)("absolute z-50", className), style: { top: top, left: left, right: right, bottom: bottom, zIndex: zIndex } }, props, { children: children }), void 0));
});
